import pConfigs from '$product/config/configs.json';
import pFeatures from '$product/config/features.json';
import gConfigs from '$gbox/config/configs.json';
import gFeatures from '$gbox/config/features.json';

const gConfig: any = { ...gConfigs };

/**
 * Endpoints the application code depends on, regardless of which store is built.
 *
 * `yarn syncstore` rsyncs the _store repo over src/product, so
 * product/config/configs.json is owned by the store, with a separate branch per
 * store. Putting a required endpoint there means adding it to every branch (nine
 * and counting) and silently breaking any store that gets missed. Anything the
 * app itself calls belongs here instead; stores can still override a value by
 * naming it in their own config, since these are merged in as the base layer.
 */
const requiredApi: any = {
  file: {
    folder: 'file-folders',
  },
};

/**
 * Merges api layers one level deeper than a spread.
 *
 * `{...a.api, ...b.api}` replaces whole groups, so a store config that defines
 * `api.file` wipes out every other `file` endpoint rather than adding to them.
 * Later layers win per key.
 */
const mergeApi = (...layers: Array<any>): any =>
  layers.reduce((acc, layer) => {
    Object.entries(layer || {}).forEach(([group, endpoints]) => {
      acc[group] =
        endpoints && typeof endpoints === 'object' && !Array.isArray(endpoints)
          ? { ...(acc[group] || {}), ...endpoints }
          : endpoints;
    });
    return acc;
  }, {});

const configs: any = {
  ...gConfigs,
  ...pConfigs,
  api: mergeApi(requiredApi, gConfig?.api, pConfigs.api),
  localStorage: [...gConfigs.localStorage, ...pConfigs.localStorage],
  display: {
    ...gConfigs.display,
    ...pConfigs.display,
  },
};

const features: any = {
  ...gFeatures,
  ...pFeatures,
};

export { configs, features };
